export default defineNuxtPlugin(async (nuxtApp) => {
  const appLoading = useAppLoadingStore();
  const route = useRoute();
  const getIsAuth = () => {
    const auth: boolean =
      route.meta.auth != null ? (route.meta.auth as boolean) : true;
    return auth;
  };
  nuxtApp.hook('app:created', async () => {
    if (!getIsAuth()) return;
    await useAppInit();
  });
  nuxtApp.hook('page:start', async (pageComponent) => {
    appLoading.setLoading(true);
  });
  nuxtApp.hook('page:finish', () => {
    appLoading.setLoading(false);

    if (!getIsAuth()) return;
    useActionsStore().start();
  });
});
